import { Link, getRouteApi } from '@tanstack/react-router'
import { ButtonGroup, IconName } from 'ui/components'
import { Button, IconButton } from 'ui/components/Buttons'
import { useDeleteAnnualReviewConfirmation } from '~bank-annual-review/hooks/useDeleteAnnualReviewConfirmation'

export const HeaderActions = () => {
  const route = getRouteApi('/_app/annual-review/detail/$companyId/$id')
  const navigate = route.useNavigate()
  const { companyId, id } = route.useParams()

  const { openDeleteAnnualReviewConfirmation, DeleteConfirmation } = useDeleteAnnualReviewConfirmation({
    onSuccess: () =>
      navigate({
        to: '/relationships/$id',
        params: { id: companyId }
      })
  })

  return (
    <>
      <DeleteConfirmation />
      <ButtonGroup margin="big">
        <Link to="/annual-review/detail/$companyId/$id/print" params={{ companyId, id }} target="_blank">
          <Button face="inherit white">Print PDF</Button>
        </Link>
        <IconButton
          face="neutral"
          icon={IconName.DELETE}
          onClick={() => openDeleteAnnualReviewConfirmation(Number(id))}
        >
          Delete Review
        </IconButton>
      </ButtonGroup>
    </>
  )
}
